import withStyles from '@material-ui/core/styles/withStyles';
import { withSnackbar } from 'notistack';
import React from "react";
import { instance } from "../../../Actions/AxiosInstance";

const styles = (theme) => ({
    button: {
        margin: theme.spacing.unit,
    },
});

class DownloadInvoice extends React.Component {
    constructor(props) {
        super(props);
        this.state = { CommonError: '' };
    }

    componentWillMount() {
        instance.get(`superuser/downloadinvoice/${this.props.match.params.subscriptionseatid}`).then((result) => {
            this.downloadPDF(result.data.result);
            this.props.enqueueSnackbar("Your invoice is Successfully Generated", { variant: 'success' });
        }).catch((error) => {
            const CommonError = error.response ? error.response.data.error.message : error.message;
            this.props.enqueueSnackbar(CommonError, { variant: 'error' });
        });
    }

    downloadPDF(pdf, fileName = 'Invoice') {
        const linkSource = `data:application/pdf;base64,${pdf}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    render() {
        return (
            <a href="#" />
        );
    }
}

export default withStyles(styles)(withSnackbar(DownloadInvoice));
